import { Styles } from "./styled";

interface IProps {
  title?: string;
  subTitle?: string;
  className?: string;
  onTitleClick?: () => void;
}

const HeaderTitle = (props: IProps) => {
  const { title, subTitle, className, onTitleClick } = props;
  return (
    <Styles className={className || ""}>
      {title && (
        <h2
          className={`title${onTitleClick ? " title--clickable" : ""}`}
          onClick={onTitleClick}
          role={onTitleClick ? "button" : undefined}
          tabIndex={onTitleClick ? 0 : undefined}
          onKeyDown={
            onTitleClick
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onTitleClick();
                  }
                }
              : undefined
          }
        >
          {title}
        </h2>
      )}
      {subTitle && <p className="sub-title">{subTitle}</p>}
    </Styles>
  );
};
export default HeaderTitle;
